import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import './styles/main.scss'

// Импортируем axios setup (настраивает interceptors)
import './plugins/axios'

const app = createApp(App)

// Подключаем Pinia (state management)
const pinia = createPinia()
app.use(pinia)

// Подключаем Router
app.use(router)

// Подключаем i18n (интернационализация)
app.use(i18n)

app.mount('#app')
